import React from "react";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import {
    IconIdentityCardFront,
    IconIdentityCardBack,
    IconSelfieCard,
    FileChip
} from "../../../../../components/buttons/IconButtons";
import {getFileIcon, getFileNameWithoutExtension} from "../../../../../Helpers/fileType";
import {formatBytes} from "../../../../../Apis/functions";
import { URL } from '../../../../../Apis/Constants';
import {fieldModelName} from "../../../../../enums/fieldModelEnum";
import {CRITERIA_MODEL} from "../../../../../components/table/Model/TableModel";
import {DATA_TYPE_MODEL, ORDER_MODEL, SEARCH_OPERATION_MODEL} from "../../../../Modals/Model/Model";
import {USER_TYPE_MODEL} from "../../../../../enums/userTypeEnum";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
export const TABS_VISITOR_UPDATE = {
    OVERVIEW: {
        INDEX: 0,
        TRANS: "overview",
    },
    IDENTITY_VERIFICATION: {
        INDEX: 1,
        TRANS: "identity_verification",
    },
    INVITATION_HISTORY: {
        INDEX: 2,
        TRANS: "invitation_history",
    },
    REQUEST_ACCESS: {
        INDEX: 3,
        TRANS: "access_request_history",
    }
}

export const IDENTITY_VALIDATION_CARD_MODEL = {
    PENDING_TO_UPLOAD_INFORMATION: {
        id: STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION,
        titleTrans: "pending_to_upload_information",
        titleClass: "font-color-shades-700",
        classCard: "card-shades-150-50",
        descriptionTransVeridas: "",
        descriptionTransManual: "",
        approverByTrans: ""
    },
    PENDING_REVIEW:  {
        id: STATUS_MODEL.PENDING_REVIEW,
        titleTrans: "pending_review",
        titleClass: "font-color-success-700",
        classCard: "card-shades-150-50",
        descriptionTransVeridas: "",
        descriptionTransManual: "",
        approverByTrans: ""
    },
    VALIDATED: {
        id: STATUS_MODEL.VALIDATED,
        titleTrans: "VALIDATED",
        titleClass: "font-color-success-700",
        classCard: "card-success-150-50",
        descriptionTransVeridas: "identity_successfully_verified_using_automatic_validation",
        descriptionTransManual: "selfie_matches_id",
        byTrans: "validated_by"
    },
    DENIED: {
        id: STATUS_MODEL.DENIED,
        titleTrans: "DENIED",
        titleClass: "font-color-error-700",
        classCard: "card-error-code-150-50",
        descriptionTransVeridas: "identity_failed_using_automatic_validation",
        descriptionTransManual: "id_selfie_mismatch",
        byTrans: "denied_by"
    },
    CANCELED: {
        id: STATUS_MODEL.CANCELED,
        titleTrans: "CANCELED",
        titleClass: "font-color-error-700",
        classCard: "card-error-code-150-50",
        descriptionTransVeridas: "",
        descriptionTransManual: "",
        byTrans: "canceled_by_admin"
    },
    getIdentityValidationStatus: function (statusId) {
        const row = Object.entries(IDENTITY_VALIDATION_CARD_MODEL).find(([key, data]) => data?.id === statusId);
        return row?.[1] || null;
    }
}

export const IDENTITY_VALIDATION_TYPE_MODEL = {
    NONE: {
        id:0,
        name:"NONE",
        trans:"pending",
        description: "waiting_for_visitor_upload",
        chipClass: "chip-shades-150-200"
    },
    MANUAL: {
        id:1,
        name:"MANUAL",
        trans:"manual",
        description: "this_validation_needs_to_be_completed",
        validatedDescription: "the_validation_was_completed",
        chipClass: "chip-secondary-150-100"
    },
    VERIDAS: {
        id:2,
        name:"VERIDAS",
        trans:"automatic",
        description: "the_validation_was_completed",
        validatedDescription: "the_validation_was_completed",
        chipClass: "chip-secondary-150-100"
    },
}

export const IDENTITY_VALIDATION_TYPE_TRANS = {
    [IDENTITY_VALIDATION_TYPE_MODEL.NONE.id]: IDENTITY_VALIDATION_TYPE_MODEL.NONE.trans,
    [IDENTITY_VALIDATION_TYPE_MODEL.MANUAL.id]: IDENTITY_VALIDATION_TYPE_MODEL.MANUAL.trans,
    [IDENTITY_VALIDATION_TYPE_MODEL.VERIDAS.id]: IDENTITY_VALIDATION_TYPE_MODEL.VERIDAS.trans,
}

export const FILE_TYPE_MODEL = {
    INE: {
        id: 1,
        identifier: "MX_IDCard_2019"
    },
    PASSPORT: {
        id: 2,
        identifier: "XX_Passport_YYYY"
    },
    VIDEO: {
        id: 3,
        identifier: "VIDEO"
    },
    SELFIE: {
        id: 4,
        identifier: "SELFIE"
    }
}

export const FILE_TYPE_SIDE_MODEL = {
    NONE: {
        id: 0,
        name: "NONE",
        trans: "none",
        identifier: "none"
    },
    OBVERSE: {
        id: 1,
        name: "OBVERSE",
        trans: "obverse",
        identifier: "obverse"
    },
    REVERSE: {
        id: 2,
        name: "REVERSE",
        trans: "reverse",
        identifier: "reverse"
    },
}

export const getIdentityValidationTypeById = (id) => {
    const row = Object.entries(IDENTITY_VALIDATION_TYPE_MODEL).find(([key, data]) => data.id === id);
    return row?.[1] || null;
};

export const IDENTITY_DOCUMENTS_MODEL = {
    SELFIE: {
        index: FILE_TYPE_SIDE_MODEL.NONE.id,
        cols:"col-sm-12 col-md-6 col-lg-4 col-xxl-2",
        titleTrans: "selfie",
        descriptionTrans: "official_identification_front",
        Icon: IconSelfieCard,
        createdAt: null,
        file: null,
        noSelfie: "waiting_for_selfie"
    },
    IDENTITY_DOCUMENT_OBVERSE: {
        index: FILE_TYPE_SIDE_MODEL.OBVERSE.id,
        cols:"col-sm-12 col-md-6 col-lg-4 col-xxl-5",
        titleTrans: "official_identification_front",
        descriptionTrans: "official_identification_front",
        Icon: IconIdentityCardFront,
        createdAt: null,
        file: null,
        noSelfie: "waiting_for_official_identification"
    },
    IDENTITY_DOCUMENT_REVERSE: {
        index: FILE_TYPE_SIDE_MODEL.REVERSE.id,
        cols:"col-sm-12 col-md-6 col-lg-4 col-xxl-5",
        titleTrans: "official_identification_back",
        descriptionTrans: "official_identification_front",
        Icon: IconIdentityCardBack,
        createdAt: null,
        file: null,
        noSelfie: "waiting_for_official_identification"
    },
    set: function (data, item) {
        let aux = getIdentityFile(data);
        return {
            ...this,
            fileType: aux.fileType,
            SELFIE:{
                ...this.SELFIE,
                createdAt: item.updatedAt || item.createdAt,
                file:  item.selfie,
            },
            IDENTITY_DOCUMENT_OBVERSE:{
                ...this.IDENTITY_DOCUMENT_OBVERSE,
                createdAt: aux.OBVERSE.createdAt,
                file:  aux.OBVERSE.file,
            },
            IDENTITY_DOCUMENT_REVERSE:{
                ...this.IDENTITY_DOCUMENT_REVERSE,
                createdAt: aux.REVERSE.createdAt,
                file:  aux.REVERSE.file,
            }
        }
    }
}

const getIdentityFile = (list) => {
    let data = {
        [FILE_TYPE_SIDE_MODEL.OBVERSE.name]: {
            file: null,
            createdAt: null
        },
        [FILE_TYPE_SIDE_MODEL.REVERSE.name]: {
            file: null,
            createdAt: null
        }
    }
    list?.map(e => {
        if(e.fileType === FILE_TYPE_MODEL.INE.id || e.fileType === FILE_TYPE_MODEL.PASSPORT.id){
            let side = null;
            if(e.side === FILE_TYPE_SIDE_MODEL.OBVERSE.id || e.side === FILE_TYPE_SIDE_MODEL.NONE.id)
                side = FILE_TYPE_SIDE_MODEL.OBVERSE.name;
            else if(e.side === FILE_TYPE_SIDE_MODEL.REVERSE.id)
                side = FILE_TYPE_SIDE_MODEL.REVERSE.name;

            data[side].file  = e.file;
            data[side].createdAt  = e.updatedAt || e.createdAt;
            data.fileType  = e.fileType;
        }
    });

    return data;
};

export const MODAL_DETAILS_OPTIONS = {
    SIMPLE: {
        name: "SIMPLE",
        visitorStatusId: [STATUS_MODEL.UNATTENDED, STATUS_MODEL.REJECTED]
    },
    COMPLETE:{
        name: "COMPLETE",
        visitorStatusId: [STATUS_MODEL.ACCEPTED, STATUS_MODEL.CANCELED]
    },
    getOption: function (visitorStatusId) {
        if(this.SIMPLE.visitorStatusId.includes(visitorStatusId))
            return this.SIMPLE.name;
        else if(this.COMPLETE.visitorStatusId.includes(visitorStatusId))
            return this.COMPLETE.name;
        return null;
    }
}

export const ACCESS_REQUEST_STATUS_CARD_MODEL = {
    [STATUS_MODEL.REQUESTED]: {
        id: STATUS_MODEL.REQUESTED,
        titleTrans: "requested",
        titleClass: "font-color-shades-700",
        classCard: "card-shades-150-50",
        byTrans: ""
    },
    [STATUS_MODEL.APPROVED]: {
        id: STATUS_MODEL.APPROVED,
        titleTrans: "approved",
        titleClass: "font-color-success-700",
        classCard: "card-success-150-50",
        byTrans: "approved_by"
    },
    [STATUS_MODEL.DENIED]: {
        id: STATUS_MODEL.DENIED,
        titleTrans: "DENIED",
        titleClass: "font-color-error-700",
        classCard: "card-error-code-150-50",
        byTrans: "denied_by"
    },
    getAccessRequestStatus: function (statusId) {
        const row = Object.entries(ACCESS_REQUEST_STATUS_CARD_MODEL).find(([key, data]) => data?.id === statusId);
        return row?.[1] || null;
    }
}

export const FILE_MODEL = {
    id: null,
    fileId: null,
    name:"",
    Icon: null,
    filePath: null,
    size: 0,
    set: function (data) {
        const userFileName = data.fileUploadDto.userFileNames[0];
        const Icon =  getFileIcon(userFileName) || FileChip;
        const name = getFileNameWithoutExtension(userFileName);
        return {
            id: data.id,
            fileId: data.fileUploadDto.id,
            name: name,
            userFileName: userFileName,
            Icon: Icon,
            filePath: URL + data.fileUploadDto.filePath,
            size: formatBytes(data.fileUploadDto.size)
        }
    }
}

export const formatName = (name) => {
    return name
        .toLowerCase()
        .split(' ')
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

export const getSearchVisitorCriteriaList = ({ option, searchElement}) => {
    const stringFields = [fieldModelName.name, fieldModelName.lastName, fieldModelName.secondLastName, fieldModelName.email, fieldModelName.phoneNumber];
    return stringFields.map(field => CRITERIA_MODEL.set({
        "dataOption": SEARCH_OPERATION_MODEL.OR,
        "fieldType": DATA_TYPE_MODEL.STRING,
        "filterKey": field,
        "operation": SEARCH_OPERATION_MODEL.CN,
        "sort": ORDER_MODEL.ASC,
        "table": option,
        "values": [searchElement]
    }))
}

export const visitorCriteria = (option) => {
    return CRITERIA_MODEL.set({
        "dataOption": SEARCH_OPERATION_MODEL.AND,
        "fieldType": DATA_TYPE_MODEL.LONG,
        "filterKey": fieldModelName.userType,
        "operation": SEARCH_OPERATION_MODEL.EQ,
        "sort": ORDER_MODEL.ASC,
        "table": option,
        "values": [USER_TYPE_MODEL.VISITOR]
    });
}
